import React from 'react';
import FormGroup from 'react-bootstrap/FormGroup'
import FormLabel from 'react-bootstrap/FormLabel'
import FormControl from 'react-bootstrap/FormControl'
import { getSettings } from '../../util/getSettings';
import { Filters } from '../../util/constants';

const NumberFloors = ({ currentFloors, onChange }) => {
  const labels = getSettings(['century', 'labels'], true);
  const options = [
    { label: 'Any', value: '0' },
    { label: '1', value: 1 },
    { label: '2', value: 2 }
  ];
  const dropdownId = `${Filters.NUMBER_FLOORS}_DROPDOWN`

  const handleChange = (e) => {
    onChange(parseInt(e.target.value));
  }

  return (
    <FormGroup className='number-floors'>
      <FormLabel className='filter-title' htmlFor={dropdownId}>{labels.numberOfFloorsLabel}</FormLabel>
      <FormControl as="select" id={dropdownId} onChange={handleChange} defaultValue={currentFloors}>
        {options.map((option, index) => (
          <option value={option.value} key={index}>{option.label}</option>
        ))}
      </FormControl>
    </FormGroup>
  );
};

export default NumberFloors;
